<template>
  <div class="mb-3 card ">
    <div class="card-header bg-secondary-3">
      <div
        v-if="value.area.letter"
        class="rounded letter-box mr-2 d-inline-flex align-items-center justify-content-center"
        :style="{
          color: value.area.letterColor || 'white',
          backgroundColor: `${value.area.letterColor}14` || '#2db78226',
          borderColor: value.area.letterColor || '#2db782',
        }"
      >
        {{ value.area.letter | empty }}
      </div>
      <span class="mr-2 ">Áreas de interés:</span>
      <b>{{ value.area.name | empty }}:</b>
      <span v-if="value.area.description">
        {{ value.area.description | empty }}
      </span>
    </div>
    <div class="card-body bg-secondary-3">
      <div class="row">
        <div class="col-md-1">
          <label class="data-name">Puntuación:</label>
          <validation-provider
            ref="score"
            v-slot="{ errors, failedRules }"
            :name="`Puntuación-${value.area.id}`"
            rules="required|integer|between:0,100"
          >
            <custom-input
              ref="scoreInput"
              v-model="scoreText"
              class="w-100 "
              :custom-error-msg="getErrorMessage(failedRules)"
              :disabled="isReadOnly"
              :error="errors[0]"
              placeholder="0-100"
              @input="changeScore"
            />
          </validation-provider>
        </div>
        <div class="col-md-2">
          <label class="data-name">Prioridad:</label>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio
              v-model="hasPriority"
              class="row"
              custom-error-msg="El campo es requerido."
              :disabled="isReadOnly"
              :error="!!errors[0]"
              is-inline
              :name="`has-priority-${value.area.id}`"
              :options="yesNotOptions"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomRadio from 'custom-radio';

import RADIO_OPTIONS from '@/utils/constants/customRadioOptions';

export default {
  name: 'AreaItem',
  components: {
    ValidationProvider,
    CustomInput,
    CustomRadio,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scoreText: '',
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    hasPriority: {
      get() {
        if (![true, false].includes(this.model.hasPriority)) return null;
        return this.model.hasPriority
          ? this.yesNotOptions[0]
          : this.yesNotOptions[1];
      },
      set({ value }) {
        this.model.hasPriority = value;
      },
    },
    getErrorMessage() {
      return (failedRules) => {
        if (!failedRules) return null;
        if (failedRules.required) return 'El campo es requerido.';
        if (failedRules.integer)
          return 'El valor debe ser un número entero (sin decimales).';
        if (failedRules.between) return 'Valor fuera de rango (0-100).';
        return null;
      };
    },
    yesNotOptions() {
      return RADIO_OPTIONS;
    },
  },
  watch: {
    'model.score': function(val) {
      const current = this.scoreText === '' ? null : Number(this.scoreText);
      if (val !== current) {
        this.scoreText = val === null || val === undefined ? '' : String(val);
      }
    },
  },
  created() {
    this.scoreText =
      this.model.score === null || this.model.score === undefined
        ? ''
        : String(this.model.score);
  },
  methods: {
    // This field is integer-only (rules include "integer"), so strip everything
    // that isn't a digit -- letters used to be silently coerced to NaN/null by
    // Number(v), and an out-of-range value was only caught by vee-validate's
    // "between" rule, which is skipped on a plain "Guardar" draft save. Clamping
    // to [0, 100] here guarantees a safe value reaches the API regardless of
    // whether the form was validated before saving.
    sanitizeScore(value) {
      return String(value == null ? '' : value).replace(/[^\d]/g, '');
    },
    changeScore(v) {
      const raw = String(v == null ? '' : v);
      const clean = this.sanitizeScore(v);
      const num = parseInt(clean, 10);
      const clamped = Number.isNaN(num)
        ? null
        : Math.min(100, Math.max(0, num));

      this.scoreText = clamped === null ? clean : String(clamped);
      this.model.score = clamped;

      if (raw !== this.scoreText) {
        this.$nextTick(() => {
          const input = this.$refs.scoreInput;
          if (input && typeof input.$forceUpdate === 'function') {
            input.$forceUpdate();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.letter-box {
  width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  border: 1px solid;
}
</style>
